import { Component, OnInit } from '@angular/core';
import { SuscriptionService } from 'src/app/service/suscription.service';
import { ActivatedRoute } from '@angular/router';
import { CatalogService } from 'src/app/service/catalog.service';
import { Datosgenerales, inizializarDatosGenarales } from 'src/app/interfaces/datosgenerales';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dash-board',
  templateUrl: './dash-board.component.html',
  styleUrls: ['./dash-board.component.scss']
})
export class DashBoardComponent implements OnInit {
  datos: Datosgenerales = inizializarDatosGenarales;

  constructor(private catalogService: CatalogService, 
    suscriptionService: SuscriptionService,
    private route: ActivatedRoute,
    private translate: TranslateService) { 
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
    if(catalogService.esOperador){
      this.datos.userRegister = undefined;
    }
    suscriptionService.getTotalMessages().subscribe(value=>{
      this.datos.messagesAllDevice = value
    })
  }

  ngOnInit(): void {
    this.obtenerDatosGenerales();

    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  private async obtenerDatosGenerales(){
    try {
      console.log("memtodo obter Datos generales")
      const response = await this.catalogService.obtenerEstadisticasGenerales();
      this.datos = response;
    } catch (error) {
      console.error("Error al obtener datos generales dashboard", error);
    }
  }

  volverObtenerDatosGenerales(){
    this.obtenerDatosGenerales();
  }
}
